
import { defineComponent, ref } from "vue";
import Sleepwalking from "../components/Sleepwalking.vue";
import Timer, { setupTimer } from "../components/Timer.vue";

class Question implements QuestionInterface {
  readonly question: string;
  readonly answer: string;

  constructor(question: string, answer: string) {
    this.answer = answer;
    this.question = question;
  }
}

interface QuestionInterface {
  readonly question: string;
  readonly answer: string;
}

interface WalkInfoInterface {
  readonly dateTime: string;
  readonly questions: Array<QuestionInterface>;
}

function setup() {
  const { canWalk, timeStart } = setupTimer();

  const question = ref("");
  const answer = ref("");

  // Данные о прогулке
  const lsQuestions = localStorage.getItem("questions");
  console.log(lsQuestions);
  let wi: WalkInfoInterface;
  const allQuestions: Array<WalkInfoInterface> = lsQuestions
    ? JSON.parse(lsQuestions)
    : new Array<WalkInfoInterface>();

  if (
    lsQuestions &&
    (new Date(allQuestions[allQuestions.length - 1].dateTime)).getTime() === timeStart.getTime()
  ) {
    wi = allQuestions[allQuestions.length - 1];
  } else {
    wi = {
      dateTime: timeStart.toString(),
      questions: new Array<Question>()
    };
    allQuestions.push(wi);
    localStorage.setItem("questions", JSON.stringify(allQuestions));
  }

  const commitNewQuestion = (que: Question) => {
    wi.questions.push(que);
    allQuestions[allQuestions.length - 1] = wi;
    localStorage.setItem("questions", JSON.stringify(allQuestions));
  };

  // Обработка ответа
  const getAnswer = () => {
    if (canWalk()) {
      if (question.value.length > 3 && question.value.search("[?]") !== -1) {
        answer.value = "Хм...";
        setTimeout(() => {
          answer.value = Math.random() < 0.5 ? "Да." : "Нет.";
          commitNewQuestion(new Question(question.value, answer.value));
        }, 1000);
      } else {
        answer.value = "Не могу разобрать вопрос.";
      }
    } else {
      answer.value = "Встретимся позже.";
    }
  };

  return {
    question,
    answer,
    getAnswer
  };
}

const Main = defineComponent({
  name: "Main",
  components: {
    Sleepwalking,
    Timer
  },
  setup
});

export default Main;
